import { render, staticRenderFns } from "./PayPalPayment.vue?vue&type=template&id=26c8d1dd"
import script from "./PayPalPayment.vue?vue&type=script&lang=js"
export * from "./PayPalPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports